import React from 'react';
import styled from '@emotion/styled';
import type { ProductEventDataList } from 'corgi-types';

import ArticlePreview, { ArticlePreviewVariant } from 'common/components/ArticlePreview';
import type { TextDecorationProps } from 'common/theme/system-utilities';
import { textDecoration } from 'common/theme/system-utilities';
import { dispatchInspirationItemClickedEvent } from '../tracking';
import type { ArticlePreviewProps } from '../types';

export interface HorizontalCardProps {
  article: ArticlePreviewProps;
  list?: ProductEventDataList;
  index: number;
  linkRef?: React.RefObject<HTMLAnchorElement>;
  onEscape?: () => void;
}

const CardLink = styled.a<TextDecorationProps>`
  ${textDecoration};
  width: 100%;
  &:hover {
    cursor: pointer;
  }
`;

const IMAGE_SIZES = [80, 80, 80, 92];

export const HorizontalCard = ({
  article,
  list,
  index,
  linkRef,
  onEscape,
}: HorizontalCardProps) => {
  const handleClick = () => {
    if (article.tracking && list) {
      dispatchInspirationItemClickedEvent({
        tracking: article.tracking,
        list,
        position: index,
      });
    }
  };

  const handleKeyDown = (e: React.KeyboardEvent) => {
    if (e.key === 'Escape' && onEscape) {
      e.preventDefault();
      onEscape();
    }
  };

  return (
    <CardLink
      href={article.url}
      textDecoration="none"
      onClick={handleClick}
      onKeyDown={handleKeyDown}
      ref={linkRef}
    >
      <ArticlePreview
        {...article}
        imageSizes={IMAGE_SIZES}
        variant={ArticlePreviewVariant.ShopTheLook}
      />
    </CardLink>
  );
};
